import {
  IsIn,
  IsNotEmpty,
  IsOptional,
} from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IAddress } from "../common";

export class ClubDonationDto {
  @IsNotEmpty()
  payment_intent_id: string;

  @IsNotEmpty()
  amount_cents: number;

  @IsNotEmpty()
  currency: string;

  @IsNotEmpty()
  donor_name: string;

  @IsNotEmpty()
  donor_email: string;

  @IsNotEmpty()
  donor_address: IAddress;

  @IsNotEmpty()
  donor_phone: string;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.payment_method_type))
  payment_method_type?: string = Constants.payment_method_type.card;

  @IsOptional()
  payment_card_type?: string = Constants.payment_card_type.unknown;
}
